import { css } from '@emotion/core';
// import { typography, fontWeights } from '../../../../../styles/typography';
// import { colorsPalette } from '../../../../../styles/colors';
// import { MediaQueries } from '../../../../../styles/Grid';
// import { errorCss } from '../../../../ui/Form/baseStyles/index.styles';

export const timeHolder = css({
  marginTop: 16,
  position: 'relative',
  zoom: 1,
  '.timepicker ': {
    position: 'relative',
    zIndex: 1,
  },

  '.icon-holder': {
    transform: 'scale(0.6)',
    margin: 'auto 0px',
  },
});
export const iconChevronHolder = css({
  position: 'absolute',
  top: 20,
  right: 16,
  zIndex: 0,

  i: {
    transform: 'scale(0.6)',
  },
});
